<template>
	<div>
		<mdb-row>
			<div style="margin-bottom: 20px;">

			</div>
		</mdb-row>
		<mdb-row>
			<mdb-col md="4" sm="6">
				<div class="form__group" style="margin-bottom: 10px;">

				    <label class="form__label">Nombre(s):</label>

				<input type="text" class="form__input" :value="this.firstName" disabled/>
				</div>
			</mdb-col>
		</mdb-row>

		<mdb-row>
			<mdb-col lg="4" md="6" sm="6" style="margin-bottom: 10px;">
				<div class="form__group">
					<label class="form__label">Apellido Paterno:</label>
					<input type="text" class="form__input" :value="this.lastName" disabled />
				</div>
			</mdb-col>
			<mdb-col lg="4" md="6" sm="6" style="margin-bottom: 10px;">
				<div class="form__group">
					<label for="segundoApellido" class="form__label">Apellido Materno:</label>
					<input type="text" id="segundoApellido" class="form__input" :value="this.motherLastName" disabled />
				</div>
			</mdb-col>
		</mdb-row>

		<mdb-row>
			<mdb-col lg="4" md="6" sm="6" style="margin-bottom: 10px;">
				<div class="form__group">
					<label for="dia" class="form__label" style="transform: translateY(3px);">Fecha de nacimiento:</label>
					<input type="text" id="birthDate" class="form__input" :value="this.birthDate" disabled/>
				</div>
			</mdb-col>
		</mdb-row>



		<mdb-row>
			<mdb-col md="4" sm="6" style="margin-bottom: 10px;">
				<div class="form__group">
					<label for="BirthEntity" class="form__label">Entidad de nacimiento:</label>
					<input type="text" id="BirthEntity" class="form__input" :value="this.birthPlace" disabled />
				</div>
			</mdb-col>
		</mdb-row>

		<!-- <mdb-row>
			<mdb-col md="4" style="margin-bottom: 10px;">
				<div class="form__group">
					<label for="INE" class="form__label">{{this.INE_PASSPORT}}</label>
					<input v-if="this.INE_PASSPORT_INF" type="text" id="UserINE" class="form__input" :value="this.INE_PASSPORT_INF" disabled />
				</div>
			</mdb-col>
		</mdb-row> -->

		<mdb-row>
			<mdb-col md="4" style="margin-bottom: 10px;">
				<div class="form__group">
					<label for="CURP" class="form__label">CURP:</label>
					<input v-if="this.CURPInfo" type="text" id="UserCURP" class="form__input" :value="this.CURPInfo" disabled />


				</div>
			</mdb-col>
		</mdb-row>

		<mdb-row>
			<mdb-col lg="4" md="6" sm="6" style="margin-bottom: 10px;">
				<div class="form__group">
					<label for="dia" class="form__label" style="transform: translateY(3px);">Documentos: </label>
				</div>
			</mdb-col>
		</mdb-row>


		<Popup size="lg" ref="confirm" :title="tituloUrl"> 
			<div class="embed-responsive embed-responsive-16by9 z-depth-1-half" style="height: 75vh;">
                    <iframe class="embed-responsive-item" :src="url" allowfullscreen></iframe>
			</div>
				<div class="accordion__button">
			<btn style="float: left;" text="CERRAR" @onClick="$refs.confirm.toggleModal()" type="primary-block" />
			</div>
			</Popup>
		
		<btn type="primary" @onClick="seeBirthPlace(BIRTH_CERTIFICATE_INF, 'Acta de nacimiento')" text="Ver Acta de nacimiento" icon="revisar" class="btn-acta-nacimiento" />
				<btn type="primary" @onClick="seeBirthPlace(urlCURP, 'CURP')" text="Ver CURP" icon="revisar" class="btn-acta-nacimiento" />
				<btn type="primary" @onClick="seeBirthPlace(urlIne, 'Identificación')" text="Ver Identificación" icon="revisar" class="btn-acta-nacimiento" />




		</div>
</template>
<script>
	import Btn from '../../core/Button';
	import Popup from "../../core/Popup"

	import { mdbContainer, mdbRow, mdbCol } from "mdbvue";
	import { mapGetters, mapMutations } from "vuex";
	import ValidationError from "../misc/ValidationError";

	export default {
		name: "BeneficiaryPersonalData",
		components: {
			mdbContainer,
			mdbRow,
			mdbCol,
			Btn,
			Popup,
			ValidationError
		},
		created(){
	
 				this.userAllData = JSON.parse(localStorage.getItem("userAllData"))
				 //console.log("userAllData", this.userAllData);
				this.firstName = this.userAllData.name;
				this.lastName = this.userAllData.lastName;
				this.motherLastName = this.userAllData.mothersLastName;
				this.birthDate = this.userAllData.birthDate;
				this.birthPlace = this.userAllData.birthPlace;

				for (let i = 0; i < this.userAllData.documents.length; i++){
						let documents = this.userAllData.documents[i]
						//console.log("documents", documents.documentType );
						
						if(documents.documentType == "CURP"){
							this.CURPInfo = documents.value;
							this.urlCURP = documents.publicURL
						}

						if(documents.documentType == "PASSPORT"){
							this.INE_PASSPORT = "Pasaporte:";
							this.INE_PASSPORT_INF = documents.value;
						}

						if(documents.documentType == "INE"){
							this.INE_PASSPORT = "INE:";
							this.INE_PASSPORT_INF = documents.value;
							this.urlIne = documents.publicURL
						}

						if(documents.documentType == "BIRTH_CERTIFICATE"){
							this.BIRTH_CERTIFICATE_INF = documents.publicURL;
						}
						
    			}

				if(this.userAllData.phones.length > 0){
					let phones = this.userAllData.phones;

				}

				
				
		},
		
		mounted(){     
		
				
		},

		updated(){	

		},

		data(){
			return {
				userAllData:"",
				infoIdIcon: 'info-default.svg',
				firstName :"",
			    lastName :"",
			    motherLastName :"",
				birthDate:"",
				birthPlace:"",
				CURPInfo:"",
				BIRTH_CERTIFICATE_INF:"",
				INE_PASSPORT:"",
				INE_PASSPORT_INF:"",
				namex:"",
				urlIne: "",
				urlCURP: "",
				tituloUrl:"",
				url: ""
			}
		},

		computed: {
			...mapGetters({
				 
			}),

            

		},
		methods: {
			chooseFile(){
				document.getElementById("fileUpload").click();
			},
			chooseFileCurp(){
				document.getElementById("fileUploadCurp").click();
			},
			chooseFileColonia(){
				document.getElementById("fileUploadColonia").click();
			},
			chooseFileCartaAntec(){
				document.getElementById("fileUploadCartaAntec").click();
			},
			chooseFileIdentificacion(){
				document.getElementById("fileUploadIdentificacion").click();
			},
			mouseOverIcon(){
				let infoIdIcon = this.infoIdIcon.split("-");
				this.infoIdIcon = `${infoIdIcon[0]}-hover.svg`;
			},
			mouseLeaveIcon(){
				let infoIdIcon = this.infoIdIcon.split("-");
				this.infoIdIcon = `${infoIdIcon[0]}-default.svg`;
			},

			seeBirthPlace(urlSrc, title){
				this.url = urlSrc,
				this.tituloUrl = title;
				this.$refs.confirm.toggleModal();
			},

			handleAuth() {
				this.$v.$touch();
				//console.log("handleAuth ...");
			},
			
			 
		}
		}
</script>
<style>
	.t1-input-colonia {
		/* max-width: 80%; */
		display: inline;
		transform: translateY(3px);
		margin-bottom: 10px !important; 
	}

	.t1-input-curp {
		display: inline; 
		max-width: 70%; 
		transform: translateY(3px);
	}

	.t1-input-dia,
	.t1-input-mes {
		text-align: center;
		display: inline; 
		width: 8%; 
		margin-right: 15px; 
		transform: translateY(3px);
	}

	.t1-input-ano {
		text-align: center; 
		display: inline; 
		width: 12%; 
		transform: translateY(3px);
	}

	.btn-comprobante-domicilio {
		/* margin-left: 10px; */
		display: inline;
	}

	.btn-acta-nacimiento {
		display: inline-block; 
		margin-left: 10px;
	}

	.btn-upload-curp {
		display: inline; 
		margin-left: 10px;
	}

	.info-icon {
		width: 2rem;
		height: 2rem;
		margin-left: 1rem;
		transition: transform .2s;
	}

	.info-icon:hover {
		transform: scale(1.3);
	}

	@media(max-width: 1199px){
		.t1-input-curp {
			display: block; 
			max-width: 100%; 
			transform: translateY(3px);
		}

		.t1-input-dia,
		.t1-input-mes {
			width: 12%; 
		}


		.t1-input-ano {
			width: 18%; 
		}

		.btn-upload-curp {
			display: block; 
			margin-top: 10px;
			margin-left: 0px;
		}

		.btn-acta-nacimiento {
			display: block; 
			margin-left: 0px;
			margin-top: 10px;
		}
	}

	@media(max-width: 992px){
		.btn-comprobante-domicilio {
			margin-left: 0px;
			display: block;
		}

		.t1-input-dia,
		.t1-input-mes {
			width: 18%; 
		}


		.t1-input-ano {
			width: 28%; 
		}


		.t1-input-colonia {
			max-width: 100%;
			margin-bottom: 10px;
			display: block;
		} 
	}

	@media(max-width: 768px){
		.t1-input-colonia {
			max-width: 100%;
		}
	}

	@media (max-width: 576px) { 

		}
</style>
